import React from 'react';
import request from '../../../../../logic/utils/request';
import { ScreenCardsBox } from '../../../../styles/HandlePoints';
import Table from '../../../../../pages/private/components/table/Table';
import Config from './TableConfig';

function ScreenCards({
  screenList, zone, fetchScreens, zoneId, screenEdit,
}) {
  const deleteZone = async (id) => {
    const screens = screenList.filter((item) => item.screenId !== id);
    const newData = { ...zone, config: { ...zone.config, screens } };
    await request(`/server/api/zone/${zoneId}/`, 'update', newData);
    fetchScreens();
  };

  const handleIcon = (e, row) => {
    const { name } = e.target.dataset;
    if (name === 'del') {
      deleteZone(row.screenId);
    } else {
      screenEdit(row.screenId);
    }
  };

  const Setting = Config();
  const { columns } = Setting;

  return (
    <ScreenCardsBox>
      {screenList && <Table keys="screenId" data={screenList} handleIcon={handleIcon} columns={columns} /> }
    </ScreenCardsBox>
  );
}

export default React.memo(ScreenCards);
